import { Record, List } from 'immutable';
import StateRecord from '~/data/StateRecord';

const keys: CountryFields = {
  name: '',
  translationKey: '',
  states: List(),
};

interface CountryFields {
  name: string;
  translationKey: string;
  states: List<StateRecord>;
}

export default class CountryRecord extends Record<CountryFields>(keys) {
  constructor(values?) {
    super(values);

    if (values && values.states) {
      return this.set(
        'states',
        List(values.states.map((state) => new StateRecord(state)))
      );
    }
    return this;
  }
}
